

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SearchForm extends Vue {
  @Prop({ type: String, default: undefined }) readonly query!: string
}
